import { Button, Col, Row } from "reactstrap";

const LocationHeader = ({ field, fullScreen, setFullScreen, onClose }) => {
  return (
    <div className="p-2 border-bottom border-superlight">
      <Row className="align-items-center">
        <Col xs="">
          <h5 className="m-0">{field?.Name ? field?.Name : "Location"}</h5>
        </Col>
        <Col xs="auto" className="pl-0">
          <Button
            className="btn-icon-only"
            onClick={() => setFullScreen((prev) => !prev)}
            size="sm"
            outline
          >
            <i
              className={`mdi mdi-${
                fullScreen ? "fullscreen-exit" : "fullscreen"
              }`}
            />
          </Button>
          <Button size="sm" outline color="secondary" onClick={onClose}>
            Done
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default LocationHeader;
